import React, { useState } from "react";

function Contact(){
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [phoneError, setPhoneError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showThanks, setShowThanks] = useState(false);

  const validateEmail = (value) => {
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setEmailError(!pattern.test(value.trim()));
  };

  const validatePhone = (value) => {
    const pattern = /^[0-9+\-()\s]{7,}$/;
    setPhoneError(!pattern.test(value.trim()));
  };

    return(
        <div>
            <section class="footer-bottom py-lg-4 py-md-3 py-sm-3 py-3" id="contact">
    <div class="container py-lg-5 py-md-4 py-sm-4 py-3">
      <h3 class="text-center title mb-3">Contact Us</h3>
      <div class="title-mid-text text-center pt-lg-3 pt-2 mb-lg-5 mb-md-4 mb-sm-4 mb-3">
        <p>
          </p>
      </div>
      <div class="row">
        {/*//contact-map */}
        <div class="address_mail_footer_grids col-lg-6 col-md-6">
        <iframe title="Sheets of Soul Yoga Shala Map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3498.412809099427!2d-13.8718083!3d28.737089400000002!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xc46359fcb91825d%3A0x6e8b574d311e5c28!2sSheets%20Of%20Soul%20Yoga%20Shala!5e0!3m2!1sen!2sin!4v1752927232531!5m2!1sen!2sin" width="600" height="450" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
          {/* <iframe src="https://www.google.com/maps/place//@28.3680677,-14.0438242,11.24z/data=!4m8!1m7!3m6!1s0xc47a473afc20f81:0x2ac71c13b5b57f23!2sFuerteventura!8m2!3d28.3587436!4d-14.053676!16zL20vMDMxaG0?entry=ttu&g_ep=EgoyMDI1MDMyNS4xIKXMDSoASAFQAw%3D%3D"></iframe> */}
        </div>
        {/*contact-map */}
        <div class="col-lg-6 col-md-6 contact-form-txt">
          <form action="https://docs.google.com/forms/d/e/1FAIpQLSc3ltlS3MFAeNw1CnPfelb4Jv8w0MzDQZc5ByXhwJRC4OtN0w/formResponse" method="post" target="hidden_iframe" onSubmit={(e) => {
            if (emailError || phoneError || !email || !phone) {
              e.preventDefault();
              validateEmail(email);
              validatePhone(phone);
            } else {
              setIsSubmitting(true);
            }
          }}>
            <div class="pvt-mid-contact-mid">
              <div class="form-group contact-forms">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Name"
                  name="entry.1404337401"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required=""
                />
              </div>
              <div class="form-group contact-forms">
                <input
                  type="email"
                  class="form-control"
                  placeholder="Email"
                  name="entry.1598830616"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    if (emailError) validateEmail(e.target.value);
                  }}
                  onBlur={() => validateEmail(email)}
                  required
                />
                {emailError && (
                  <small class="text-danger">Please enter a valid email address.</small>
                )}
              </div>
              <div class="form-group contact-forms">
                <input
                  type="tel"
                  class="form-control"
                  placeholder="Phone"
                  name="entry.1774648554"
                  value={phone}
                  onChange={(e) => {
                    setPhone(e.target.value);
                    if (phoneError) validatePhone(e.target.value);
                  }}
                  onBlur={() => validatePhone(phone)}
                  required
                />
                {phoneError && (
                  <small class="text-danger">Please enter a valid Phone Number.</small>
                )}
              </div>
              <div class="form-group contact-forms">
                <textarea
                  class="form-control"
                  placeholder="Message"
                  rows="3"
                  name="entry.1722935520"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  required=""
                ></textarea>
              </div>
              <button type="submit" class="btn sent-butnn">Send</button>
            </div>
          </form>
          <iframe
            name="hidden_iframe"
            id="hidden_iframe"
            title="Form submission frame"
            style={{ display: "none" }}
            onLoad={() => {
              if (isSubmitting) {
                setShowThanks(true);
                setIsSubmitting(false);
                setName("");
                setEmail("");
                setPhone("");
                setMessage("");
              }
            }}
          ></iframe>
           {/* WhatsApp Button */}
          <div class="whatsapp-container">
          <a href="https://wa.me/919839188783?text=Hi Jigyasa, I would like to know more about your services." 
             class="whatsapp-btn" target="_blank" rel="noreferrer">
            <img src="assets/images/whatsapp-icon.jpg" alt="WhatsApp" class="whatsapp-icon"/> Chat on WhatsApp
          </a>
        </div>
        </div>
      </div>
    </div>
  </section>
  {showThanks && (
    <div
      class="thanks-overlay"
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1050
      }}
      onClick={() => setShowThanks(false)}
    >
      <div
        class="thanks-modal"
        style={{
          background: "#fff",
          padding: "24px",
          borderRadius: "8px",
          maxWidth: "420px",
          width: "90%",
          textAlign: "center",
          boxShadow: "0 10px 30px rgba(0,0,0,0.2)"
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <h5 style={{ marginBottom: "8px" }}>Thank you for connecting with us!</h5>
        <p style={{ marginBottom: "16px" }}>We will contact you shortly.</p>
        <button class="btn sent-butnn" onClick={() => setShowThanks(false)}>OK</button>
      </div>
    </div>
  )}
        </div>
    )
}
export default Contact;